import { SportsRequest } from "sb-bff-integration";
export var LibConfig = {
    regionIds: [],
    sportIds: [],
    eventState: SportsRequest.EventStateEnum.Mixed,
    allRegions: []
};
export var init = function (config) {
    LibConfig.regionIds = config.regionIds;
    LibConfig.sportIds = config.sportIds;
};
//# sourceMappingURL=init.js.map